import { render, staticRenderFns } from "./question-dropDown.vue?vue&type=template&id=494c3cd0&scoped=true&"
import script from "./question-dropDown.vue?vue&type=script&lang=js&"
export * from "./question-dropDown.vue?vue&type=script&lang=js&"
import style0 from "./question-dropDown.vue?vue&type=style&index=0&id=494c3cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c3cd0",
  null
  
)

export default component.exports